
export const MODULE_NAME = 'lk-roadmaps-experts'

export const LK_ROADMAPS_EXPERTS_ROUTES = {
  LAYOUT: MODULE_NAME,
  LAYOUT_READONLY: `${MODULE_NAME}.read`,
} as const
